

































































































import EmployeeQuotasSummaryView from "@/components/EmployeeQuotasSummaryView.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: { EmployeeQuotasSummaryView }
})
export default class EmployeeSummaryView extends Vue {
  @Prop() summary: any;
}
